module.exports = __webpack_public_path__ + "static/media/location6.c6ed09e3.webp";